var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoneIconGreen = function SvgPhoneIconGreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9FFE8",
    fillRule: "evenodd",
    d: "M6.246 8.821a.674.674 0 0 1 .315-1.128l.978-.252-.333-4.607S5.767 2.2 4.582 3.1s-1.3 3.703-1.097 5.057c.204 1.355.782 3.218 2.47 5.192 1.688 1.975 4.722 3.399 7.035 3.355 2.4-.291 2.78-3.09 2.78-3.09l-3.976-1.152-.384.461a.674.674 0 0 1-.992.051L6.246 8.821Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M5.392 7.734a.674.674 0 0 1 .314-1.128l.979-.252-.333-4.607s-1.44-.635-2.625.264c-1.185.9-1.3 3.704-1.096 5.058.203 1.354.782 3.218 2.47 5.192 1.688 1.975 4.721 3.399 7.035 3.355 2.4-.292 2.78-3.09 2.78-3.09l-3.976-1.152-.385.46a.674.674 0 0 1-.992.052L5.392 7.734Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneIconGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "PhoneIconGreen.b5fdb935342f31c53eaa197045f143c8.svg";